// removed by extract-text-webpack-plugin
module.exports = {"form":"TaskList__form___3HUxX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TaskList/TaskList.scss
// module id = 1201
// module chunks = 1